// extracted by mini-css-extract-plugin
module.exports = {"buttons":"FittingOrders_buttons__A-mOi","button":"FittingOrders_button__GXCT9"};